import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ExpenseService {
  static createExpense(expense) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/new`;
    const body = {
      expense
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static loadExpenses(body) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}`;
    return axios.post(url, body).then((response) => response.data);
  }

  static getExpense(id) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadExpensesByCustomerId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/customer/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadExpensesByEmployeeId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/employee/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadExpensesByFilters(body) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/filtered`;
    return axios.post(url, body).then((response) => response.data);
  }

  static updateExpense(expense) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${expense.id}`;
    const body = {
      expense
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteExpense(id) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static uploadFile(file) {
    const formData = new FormData();
    formData.append("expenseUpload", file);

    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/upload`;

    return axios.post(url, formData);
  }

  static createReceipt(expense, receipt) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${expense.id}/receipt`;
    const body = {
      receipt: {
        path: receipt.fileName
      }
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static downloadFile(expense, file) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${expense.id}/receipt/${file}`;

    return axios.get(url).then((response) => {
      // simulate DOM click for download <- doi
      const file_path = response.data.url;
      const a = document.createElement("A");
      a.href = file_path;
      a.target = "_blank;";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      return response.data;
    });
  }

  static updateReceipt(expense, receipt) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${expense.id}/receipt`;
    const body = {
      receipt
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteReceipt(customer, receipt) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/${customer.id}/receipt/delete`;
    const body = {
      receipt
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateManyExpenses(expenses) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPENSES}/update-many`;
    const body = {
      expenses
    };

    return axios.post(url, body).then((response) => response.data);
  }
}

export default ExpenseService;
